import React, { memo } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import Grid from 'transfix-ui/core/Grid'
import { theme } from 'transfix-ui/theme'
import { Maybe } from 'types/graphqlTypes'
import { ActiveStatus } from '../../ActiveStatus'

interface IConnectionConfigDetailsGridProps {
  gridHash: { label: string; value: Maybe<string | number | boolean> }
}

const useConnectionConfigDetailsGridStyles = makeStyles({
  container: {
    margin: theme.spacing(1),
  },
  text: {
    whiteSpace: 'pre-line',
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
  },
})

export const ConnectionConfigDetailsGrid = memo<IConnectionConfigDetailsGridProps>(
  ({ gridHash }) => {
    const classes = useConnectionConfigDetailsGridStyles()
    const rowValue = (value: Maybe<string | number | boolean>) => {
      if (typeof value !== 'boolean') {
        return <span className={classes.text}>{value}</span>
      }
      return <ActiveStatus disabled={!value} />
    }

    return (
      <Grid container justifyContent='flex-start' spacing={1} className={classes.container}>
        <Grid item lg={4} sm={12} xs={12} md={4}>
          <Typography variant='h6'>{gridHash.label}</Typography>
        </Grid>
        <Grid item className={classes.gridItem} lg={8} sm={12} xs={12} md={8}>
          {rowValue(gridHash.value)}
        </Grid>
      </Grid>
    )
  }
)
